import React from 'react';
import { ExternalLink } from 'lucide-react';

/**
 * Static preview of an ad — renders both the full-card variant (used in feed)
 * and the compact variant (used in sidebars), driven directly off form state.
 * No network calls.
 */
const AdPreview = ({ ad }) => {
  const headline = (ad.headline || '').trim() || 'Headline preview';
  const body = (ad.body || '').trim();
  const ctaLabel = (ad.cta_label || 'Learn More').trim() || 'Learn More';
  const image = ad.image_url || null;
  const placements = ad.placements || [];
  const showFeed = placements.length === 0 || placements.includes('feed');
  const showCompact = placements.length === 0
    || placements.includes('spaces_sidebar')
    || placements.includes('dashboard_sidebar');

  return (
    <div className="space-y-3" data-testid="ad-preview">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-text-muted">Live preview</span>
        <span className="text-[10px] text-text-muted/60">Updates as you type</span>
      </div>

      {showFeed && (
        <div>
          <p className="text-[10px] uppercase tracking-wider text-text-muted/70 mb-1">Feed</p>
          <div className="rounded-arch-xl border border-primary/15 bg-white/60 dark:bg-white/10 backdrop-blur p-4 flex gap-3 items-start">
            {image
              ? <img src={image} alt="" className="w-20 h-20 object-cover rounded-arch flex-shrink-0" />
              : <div className="w-20 h-20 rounded-arch bg-primary/10 flex-shrink-0" />}
            <div className="flex-1 min-w-0">
              <span className="text-[10px] uppercase tracking-wider text-text-muted/70">Sponsored</span>
              <p className="text-sm font-medium text-text-main leading-snug mt-0.5 line-clamp-2">{headline}</p>
              {body && <p className="text-xs text-text-muted leading-relaxed mt-1 line-clamp-2">{body}</p>}
              <span className="inline-flex items-center gap-1 mt-2 px-2.5 py-1 rounded-full text-[11px] font-medium bg-primary text-white">
                {ctaLabel} <ExternalLink className="w-3 h-3" />
              </span>
            </div>
          </div>
        </div>
      )}

      {showCompact && (
        <div>
          <p className="text-[10px] uppercase tracking-wider text-text-muted/70 mb-1">Sidebar</p>
          <div className="max-w-xs rounded-arch border border-primary/15 bg-white/60 dark:bg-white/10 backdrop-blur p-3 space-y-1.5">
            <span className="text-[10px] uppercase tracking-wider text-text-muted/70">Sponsored</span>
            {image && <img src={image} alt="" className="w-full h-20 object-cover rounded-md" />}
            <p className="text-sm font-medium text-text-main leading-snug line-clamp-2">{headline}</p>
            {body && <p className="text-xs text-text-muted leading-relaxed line-clamp-2">{body}</p>}
            <span className="inline-flex items-center gap-1 text-xs font-medium text-primary">
              {ctaLabel} <ExternalLink className="w-3 h-3" />
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdPreview;
